import { ProgramCodes } from '@mesa-labs/mesa-api/dist/types';
import { useLocation } from 'react-router-dom';

import { useFeatureFlags } from '../contexts/FeatureFlagProvider';
import { useRenderLatestServiceAgreementQuery } from '../redux/api/vendor';
import useServiceAgreementQueryArgs from './useServiceAgreementQueryArgs';

const PRELOAD_PATHS = [
  '/onboarding/bank-info-selection',
  '/onboarding/bank-info',
  '/onboarding/direct-debit-agreement',
  '/onboarding/acknowledge-direct-debit-agreement',
  '/onboarding/terms',
];

// Keeping the subscription open from the step before /terms through /terms
// keeps the cached agreement alive, so /terms renders without a loading state.
// The endpoint rejects empty vendor details, so the preload waits until they're set.
function usePreloadServiceAgreement(): void {
  const { pathname } = useLocation();
  const featureFlags = useFeatureFlags();
  const args = useServiceAgreementQueryArgs();

  // The on-demand schedule step only sets the OD program code on submit, right
  // before navigating to /terms, so preload with the code Terms will use.
  const isOnDemandSkippingBank = pathname === '/onboarding/on-demand-schedule'
    && featureFlags.onDemandOnboardingSkipsBankAccountStep;

  const hasRequiredFields = [
    args.businessName,
    args.address,
    args.city,
    args.state,
    args.zip,
    args.firstName,
    args.lastName,
  ].every(Boolean);

  useRenderLatestServiceAgreementQuery(
    isOnDemandSkippingBank ? { ...args, programCode: ProgramCodes.OD } : args,
    { skip: !hasRequiredFields || (!isOnDemandSkippingBank && !PRELOAD_PATHS.includes(pathname)) },
  );
}

export default usePreloadServiceAgreement;
